import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ImportBatchList from './ImportBatchList';
import ImportBatchDetail from './ImportBatchDetail';
var Imports = function (_a) {
    var match = _a.match;
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: match.path, component: ImportBatchList }),
        React.createElement(Route, { path: ["".concat(match.path, "/:batchId/items/:itemId"), "".concat(match.path, "/:batchId")], component: ImportBatchDetail })));
};
export default Imports;
